import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Box } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

export const ReportsDateRangePicker = ({
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  size = "medium"
}: {
  fromDate: Date | null;
  toDate: Date | null;
  setFromDate: Dispatch<SetStateAction<Date | null>>;
  setToDate: Dispatch<SetStateAction<Date | null>>;
  size?: "small" | "medium";
}) => {
  const { t } = useTranslation();
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ display: "flex", flexDirection: "row", gap: 1, flexWrap: "wrap", py: size === "small" ? 0 : 1 }}>
        <div>
          <DatePicker
            label={t("From Date")}
            value={fromDate}
            onChange={(newValue) => setFromDate(newValue)}
            slotProps={{ textField: { size } }}
          />
        </div>
        <div>
          <DatePicker
            label={t("To Date")}
            value={toDate}
            onChange={(newValue) => setToDate(newValue)}
            slotProps={{ textField: { size } }}
          />
        </div>
      </Box>
    </LocalizationProvider>
  );
};
